import React from "react";
import { Navigate, useParams } from "react-router-dom";
import {
    ADMIN_CRM_CONTACTS_PATH,
    ADMIN_CRM_FEEDBACK_PATH,
    ADMIN_CRM_MAILING_LIST_PATH,
    ADMIN_CRM_REFERRAL_PATH,
    adminCrmFeedbackDetailPath,
    adminCrmReferralEventPath,
    adminCrmReferralInvitersPath,
} from "./crmRoutes";
import { loadCrmTabPath } from "./CrmTabs";

export function RedirectToCrmHome() {
    return <Navigate to={loadCrmTabPath()} replace />;
}

export function RedirectLegacyMailingList() {
    return <Navigate to={ADMIN_CRM_MAILING_LIST_PATH} replace />;
}

export function RedirectLegacyContacts() {
    return <Navigate to={ADMIN_CRM_CONTACTS_PATH} replace />;
}

export function RedirectLegacyReferral() {
    return <Navigate to={ADMIN_CRM_REFERRAL_PATH} replace />;
}

export function RedirectLegacyReferralEvent() {
    const { eventId } = useParams();
    return <Navigate to={adminCrmReferralEventPath(eventId)} replace />;
}

export function RedirectLegacyReferralInviters() {
    const { eventId } = useParams();
    return <Navigate to={adminCrmReferralInvitersPath(eventId)} replace />;
}

export function RedirectLegacyFeedback() {
    return <Navigate to={ADMIN_CRM_FEEDBACK_PATH} replace />;
}

export function RedirectLegacyFeedbackDetail() {
    const { feedbackId } = useParams();
    return <Navigate to={adminCrmFeedbackDetailPath(feedbackId)} replace />;
}
